import { Components, Theme } from '@mui/material';

const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    label: ({ theme, ownerState }) =>
      ownerState.variant === 'filled' &&
      ownerState.color === 'default' && {
        color: theme.palette.grey[600],
      },
    labelSmall: ({ theme }) => ({
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    }),
  },
};

export default MuiChip;
